/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillEditSuggestion,
  SkillEditSuggestion$inboundSchema,
} from "./skilleditsuggestion.js";
import { SkillVersion, SkillVersion$inboundSchema } from "./skillversion.js";

/**
 * Whether the suggestion created a version, created one and stayed open carrying its remaining changes, or was stale.
 */
export const ApproveSkillSuggestionResultOutcome = {
  Applied: "applied",
  PartiallyApplied: "partially_applied",
  Superseded: "superseded",
} as const;
/**
 * Whether the suggestion created a version, created one and stayed open carrying its remaining changes, or was stale.
 */
export type ApproveSkillSuggestionResultOutcome = ClosedEnum<
  typeof ApproveSkillSuggestionResultOutcome
>;

/**
 * The result of approving one suggestion.
 */
export type ApproveSkillSuggestionResult = {
  /**
   * Whether the suggestion created a version, created one and stayed open carrying its remaining changes, or was stale.
   */
  outcome: ApproveSkillSuggestionResultOutcome;
  /**
   * A proposed edit to an existing project skill.
   */
  suggestion: SkillEditSuggestion;
  /**
   * An immutable version of a skill manifest.
   */
  version?: SkillVersion | undefined;
};

/** @internal */
export const ApproveSkillSuggestionResultOutcome$inboundSchema: z.ZodMiniEnum<
  typeof ApproveSkillSuggestionResultOutcome
> = z.enum(ApproveSkillSuggestionResultOutcome);

/** @internal */
export const ApproveSkillSuggestionResult$inboundSchema: z.ZodMiniType<
  ApproveSkillSuggestionResult,
  unknown
> = z.object({
  outcome: ApproveSkillSuggestionResultOutcome$inboundSchema,
  suggestion: SkillEditSuggestion$inboundSchema,
  version: z.optional(SkillVersion$inboundSchema),
});

export function approveSkillSuggestionResultFromJSON(
  jsonString: string,
): SafeParseResult<ApproveSkillSuggestionResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ApproveSkillSuggestionResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ApproveSkillSuggestionResult' from JSON`,
  );
}
